/* tslint:disable */

declare var Object: any;
export interface PropertyFileInterface {
  "property_id": number;
  "file_description": string;
  "file_path": string;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
}

export class PropertyFile implements PropertyFileInterface {
  "property_id": number;
  "file_description": string;
  "file_path": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  constructor(data?: PropertyFileInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PropertyFile`.
   */
  public static getModelName() {
    return "PropertyFile";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PropertyFile for dynamic purposes.
  **/
  public static factory(data: PropertyFileInterface): PropertyFile{
    return new PropertyFile(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PropertyFile',
      plural: 'PropertyFiles',
      path: 'PropertyFiles',
      idName: 'id',
      properties: {
        "property_id": {
          name: 'property_id',
          type: 'number'
        },
        "file_description": {
          name: 'file_description',
          type: 'string'
        },
        "file_path": {
          name: 'file_path',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
      }
    }
  }
}
